import script from "./Checkbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./Checkbox.vue?vue&type=script&setup=true&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=631e9b3a&lang=scss"

const __exports__ = script;

export default __exports__